import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconVisibilitySvg } from "./IconVisibilitySvg.mjs";
const IconVisibility = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconVisibilitySvg, ...iconProps });
};
export {
  IconVisibility
};
